import React from "react";
import Card from './../elements/cards'
import {IconClock, IconHistory} from "@tabler/icons-react";
import SystemStatusTable from "../elements/SystemStatusTable";

const ResponseCard = () => {
    return (
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            {/*
            <Card
                icon="📅"
                title="Response Date:"
                value="2023-07-10 00:01:02"
            />
            <Card
                icon="📅"
                title="Next update should be before"
                value="2023-07-11 01:01:02"
            />
            */}
        </div>
    );
};

const systemItems = [
    {
        name: "Response Date",
        value: "2025-03-15 10:00",
        icon: <IconClock size={30} color="var(--bs-info)" />,
    },
    {
        name: "Next update should be before",
        value: "2023-07-11 01:01:02",
        icon: <IconHistory size={30} color="var(--bs-info)" />,
    },
    {
        name: "Ethernet Traffic",
        value: "172.71.160.34",
        icon: <IconHistory size={30} color="var(--bs-info)" />,
    },
];

const Dashboard = (props) => {
    return <>
        <SystemStatusTable systemItems={systemItems} softwareItems={[]} />
    </>
}

export default Dashboard;
